import * as React from 'react';
import { Image as ImageIcon } from 'lucide-react';
import { Project, MarkupState } from '@shared/types/tsk';
import { TradeLegend } from './TradeLegend';

interface GeminiPage2ContentProps {
  project: Project | undefined;
  markup: MarkupState;
  flattenedPlan: string | null;
}

export const GeminiPage2Content: React.FC<GeminiPage2ContentProps> = ({ project, markup, flattenedPlan }) => {
  return (
    <>
      <div className="flex justify-between items-center border-b-2 border-[#0f172a] pb-8 mb-10 shrink-0">
        <div>
          <h2 className="text-2xl font-black uppercase tracking-tighter text-[#0f172a]">As Constructed Site Plan</h2>
          <p className="text-xs font-bold text-[#94a3b8] uppercase tracking-widest mt-1">{project?.address}</p>
        </div>
        <div className="text-right">
          <div className="text-sm font-black text-[#0f172a]">REF: TS-{project?.id.slice(-5)}</div>
          <div className="text-[10px] font-bold text-[#94a3b8] uppercase tracking-widest mt-1">Page 02 / 02</div>
        </div>
      </div>
      {/* Image container */}
      <div className="flex-1 flex flex-col justify-center min-h-0 border-2 border-[#0f172a] bg-white relative overflow-hidden rounded-sm">
        {flattenedPlan ? (
          <img
            src={flattenedPlan}
            alt="Technical Plan"
            className="max-w-full max-h-full w-auto h-auto object-contain mx-auto"
          />
        ) : (
          <div className="flex flex-col items-center justify-center text-slate-200 gap-4">
            <ImageIcon size={64} />
            <span className="text-xs font-black uppercase tracking-widest">Awaiting Plan Flattening</span>
          </div>
        )}
        {/* Legend Overlay */}
        <TradeLegend 
          markup={markup} 
          variant="preview" 
          className="absolute bottom-6 right-6" 
        />
      </div>
      {/* Footer Section */}
      <div className="mt-10 pt-10 border-t-2 border-[#f1f5f9] flex justify-between items-center shrink-0">
        <div className="flex gap-16">
          <div className="space-y-1.5">
            <p className="text-[10px] font-black text-[#94a3b8] uppercase tracking-wider">Licensed Professional</p>
            <p className="text-base font-black uppercase">{project?.clientName || 'Unspecified'}</p>
          </div>
          <div className="space-y-1.5">
            <p className="text-[10px] font-black text-[#94a3b8] uppercase tracking-wider">License Number</p>
            <p className="text-base font-black uppercase">{project?.approvalNo || '-------'}</p>
          </div>
        </div>
        <p className="text-[10px] font-black text-slate-300 uppercase tracking-[0.4em]">Official Submission Document</p>
      </div>
    </>
  );
};
